import {
  //
  ADD_BODYMAP,
  ADD_BODYMAP_FAILURE,
  ADD_BODYMAP_SUCCESS,
  //
  DELETE_BODYMAP,
  DELETE_BODYMAP_FAILURE,
  DELETE_BODYMAP_SUCCESS,
  //
  EDIT_BODYMAP,
  EDIT_BODYMAP_FAILURE,
  EDIT_BODYMAP_SUCCESS,
  //
  FETCH_BODYMAP,
  FETCH_BODYMAP_FAILURE,
  FETCH_BODYMAP_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
} from "./constants";

// List
export const fetchBodyMap = (payload, onSuccess) => ({
  type: FETCH_BODYMAP,
  payload,
  onSuccess,
});
export const fetchBodyMapSuccess = (payload) => ({
  type: FETCH_BODYMAP_SUCCESS,
  payload,
});
export const fetchBodyMapFailure = (payload) => ({
  type: FETCH_BODYMAP_FAILURE,
  payload,
});
// View
export const getViewData = (payload, onSuccess) => ({
  type: GET_VIEW_DATA,
  payload,
  onSuccess,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addBodyMap = (payload, onAdd) => ({
  type: ADD_BODYMAP,
  payload,
  onAdd,
});
export const addBodyMapSuccess = (payload) => ({
  type: ADD_BODYMAP_SUCCESS,
  payload,
});
export const addBodyMapFailure = (payload) => ({
  type: ADD_BODYMAP_FAILURE,
  payload,
});
// EDIT
export const editBodyMap = (payload, onEdit) => ({
  type: EDIT_BODYMAP,
  payload,
  onEdit,
});
export const editBodyMapSuccess = (payload, onEdit) => ({
  type: EDIT_BODYMAP_SUCCESS,
  payload,
});
export const editBodyMapFailure = (payload) => ({
  type: EDIT_BODYMAP_FAILURE,
  payload,
});
// DELETE
export const deleteBodyMap = (payload, onDelete) => ({
  type: DELETE_BODYMAP,
  payload,
  onDelete,
});
export const deleteBodyMapSuccess = (payload) => ({
  type: DELETE_BODYMAP_SUCCESS,
  payload,
});
export const deleteBodyMapFailure = (payload) => ({
  type: DELETE_BODYMAP_FAILURE,
  payload,
});
